import Vue from "vue";
import VueRouter from "vue-router";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import axios from "axios";
import "./assets/css/initialize.css";
import "./assets/css/index.css";
import preventReClick from "./assets/js/preventRepeatClick.js";
import "./assets/css/animate.css";
import Alertify from "alertify.js";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import AppUtils from "./utils";
import VeeValidate, { Validator } from "vee-validate";
import store from "./store/index";
// import Map from './assets/js/map'
import * as filters from "./assets/js/filter";
import VueAMap from "vue-amap";
// import  './assets/js/sockjs.min'
// import  './assets/js/stomp'
import envConfig from "./common/env";
import VueClipboard from "vue-clipboard2";
import { mavonEditor } from "mavon-editor";
import VCharts from "v-charts";

import Print from './assets/js/print'
Vue.use(Print)
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

import "mavon-editor/dist/css/index.css";
import less from "less";
Vue.use(less);
Vue.use(VueClipboard);
Vue.use(VCharts);
Vue.use(preventReClick);
Viewer.setDefaults({
	Options: {
		inline: true,
		button: true,
		navbar: true,
		title: true,
		toolbar: true,
		tooltip: true,
		movable: true,
		zoomable: true,
		rotatable: true,
		scalable: true,
		transition: true,
		fullscreen: true,
		keyboard: true,
		url: "data-source",
	},
	/* 
	 backdrop: true, // 是否启用播放模态背景[布尔值/字符串：默认true](不启用时，点击空白处不会退出播放，仅点击右上角关闭按钮才会退出播放)
		inline: false, // 启用inline模式[布尔值：默认false]
		button: true, // 显示右上角关闭按钮[布尔值：默认true]
		navbar: false, // 显示缩略图导航[布尔值/数字：默认true]
		title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
		toolbar: false, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
		tooltip: true, // 显示缩放百分比[布尔值：默认true]
		movable: true, // 图片是否可移动[布尔值：默认true]
		zoomable: true, // 图片是否可缩放[布尔值：默认true]
		rotatable: true, // 图片是否可旋转[布尔值：默认true]
		scalable: true, // 图片是否可翻转[布尔值：默认true]
		transition: true, // 使用CSS3过渡[布尔值：默认true]
		fullscreen: true, // 播放时是否全屏[布尔值/全屏配置：默认true]
		keyboard: true, // 是否支持键盘[布尔值：默认true]
		url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
    
	*/
});

Vue.use(Viewer);
VueAMap.initAMapApiLoader({
	key: "2b61ab1e0542c52b9ff0ae03870274ca",
	plugin: [
		"AMap.Autocomplete",
		"AMap.PlaceSearch",
		"AMap.DistrictSearch",
		"AMap.Scale",
		"AMap.OverView",
		"AMap.ToolBar",
		"AMap.MapType",
		"AMap.PolyEditor",
		"AMap.CircleEditor",
		"AMap.Geocoder",
		"Scale",
		"AMap.Heatmap",
		"AMap.MouseTool",
	],
	// 默认高德 sdk 版本为 1.4.4

	v: "1.4.4",
});
import { message } from "./common/resetMessage.js";
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key]);
});
Alertify.logPosition("bottom right");
Alertify.maxLogItems(6);
Alertify.okBtn("确认");
Alertify.cancelBtn("取消");
axios.interceptors.request.use(
	function (config) {
		var arr = config.url.split("/");
		// 这里的config包含每次请求的内容
		if (
			arr.indexOf("heart") < 0 &&
			arr.indexOf("polling") < 0 &&
			arr.indexOf("onlineStatus") < 0 &&
			arr.indexOf("evidences") < 0 &&
			arr.indexOf("responsibility") < 0 &&
			arr.indexOf("receptionCenter") < 0 &&
			arr.indexOf("editData") < 0 &&
			arr.indexOf("relevent") < 0 &&
			arr.indexOf("dashboard") < 0 &&
			arr.indexOf("pool") < 0 &&
			arr.indexOf("hasNoReadFlag") < 0 &&
			arr.indexOf("status") < 0
		) {
			store.state.isLoading = true;
		}
		if (
			store.state.token &&
			arr.indexOf("login") < 0 &&
			arr.indexOf("rescue-master") < 0
		) {
			config.headers["TR-TOKEN"] = store.state.token;
		}
		config.headers["front-version"] = "5.0.0";
		return config;
	},
	function (err) {
		return Promise.reject(err);
	}
);
// axios 统一处理网络错误
axios.interceptors.response.use(
	(response) => {
		store.state.isLoading = false;
		if (response.status == "200") {
			return response;
		} else if (response.status == "505") {
			Alertify.alert(response.data.message);
			return Promise.reject(response);
		} else if (response.status == "300") {
			Alertify.alert(response.data.message);
			return Promise.reject(response);
		} else if ([403, 404].indexOf(response.status) > -1) {
			this.$router.replace("/404");
		} else {
			Alertify.alert(response.data.message);
			return Promise.reject(response);
		}
	},
	(error) => {
		store.state.isLoading = false;
		Alertify.alert("网络请求失败");
		return Promise.reject(error);
	}
);

axios.defaults.baseURL = envConfig.baseUrl;
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueAMap);
Vue.use(VeeValidate, {
	errorBagName: "vaerrors",
	inject: true,
	enableAutoClasses: true,
	events: "change",
	classNames: {
		invalid: "invalid", // model is invalid
	},
	fieldsBagName: "fieldBags",
});
Vue.component("nt-pagination", require("./components/pagination"));
Vue.component("nt-date-selector", require("./components/date-selector"));
Vue.component("nt-no-data", require("./components/no-data"));
Vue.component("nt-pulse-loader", require("./components/pulse-loader"));
Vue.component("nt-preview-image", require("./components/preview-image-single"));
Vue.component("nt-send", require("./components/sendMask"));
// Vue.component('nt-auth', require('./components/auth'));
Vue.component("mavonEditor", mavonEditor);
Vue.prototype.AppUtils = AppUtils;
// Vue.prototype.Map = Map;
// Vue.prototype.VueAMap = VueAMap;
Vue.prototype.$message = message;
Vue.prototype.$axios = axios;
Vue.prototype.$bus = new Vue();
Vue.directive("preventReClick", {
	inserted(el, binding) {
		el.addEventListener("click", () => {
			if (!el.disabled) {
				el.disabled = true;
				setTimeout(() => {
					el.disabled = false;
				}, binding.value || 2000);
			}
		});
	},
});
Vue.directive("preventReClick", {
	inserted(el, binding) {
		el.addEventListener("click", () => {
			if (!el.disabled) {
				el.disabled = true;
				setTimeout(() => {
					el.disabled = false;
				}, binding.value || 2000);
			}
		});
	},
});
Vue.mixin({
	data() {
		return {
			CODE_SERVER: envConfig.baseUrl,
			configuration: envConfig.configuration,
		};
	},
	methods: {
		poolList() {
			this.$router.push("/infos");
		},
		reportList() {
			this.$router.push("/report");
		},
		sortDevName(str1, str2) {
			let res = 0;
			for (let i = 0; ; i++) {
				if (!str1[i] || !str2[i]) {
					res = str1.length - str2.length;
					break;
				}
				const char1 = str1[i];
				const char1Type = this.getChartType(char1);
				const char2 = str2[i];
				const char2Type = this.getChartType(char2);
				// 类型相同的逐个比较字符
				if (char1Type[0] === char2Type[0]) {
					if (char1 === char2) {
						continue;
					} else {
						if (char1Type[0] === "zh") {
							res = char1.localeCompare(char2);
						} else if (char1Type[0] === "en") {
							res = char1.charCodeAt(0) - char2.charCodeAt(0);
						} else {
							res = char1 - char2;
						}
						break;
					}
				} else {
					// 类型不同的，直接用返回的数字相减
					res = char1Type[1] - char2Type[1];
					break;
				}
			}
			return res;
		},
		getChartType(char) {
			// 数字可按照排序的要求进行自定义，我这边产品的要求是
			// 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
			if (/^[\u4e00-\u9fa5]$/.test(char)) {
				return ["zh", 300];
			}
			if (/^[a-zA-Z]$/.test(char)) {
				return ["en", 200];
			}
			if (/^[0-9]$/.test(char)) {
				return ["number", 100];
			}
			return ["others", 999];
		},
	},
});
new Vue({
	store,
	router,
	components: { App },
	template: "<App/>",
	created() {
		AppUtils.authInit(this).then(() => this.$mount("#app"));
	},
});



// WEBPACK FOOTER //
// ./src/main.js